import { render, staticRenderFns } from "./MedicineAddCarePlan.vue?vue&type=template&id=53a73a90&scoped=true"
import script from "./MedicineAddCarePlan.vue?vue&type=script&lang=js"
export * from "./MedicineAddCarePlan.vue?vue&type=script&lang=js"
import style0 from "./MedicineAddCarePlan.vue?vue&type=style&index=0&id=53a73a90&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a73a90",
  null
  
)

export default component.exports